import { REGISTER_SUCCESS, REGISTER_FAIL, LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT, SET_USER } from "../actions/types";

const userString = localStorage.getItem("user");
const tokenString = localStorage.getItem("token");
const user = userString ? JSON.parse(userString) : null;
const token = tokenString ? JSON.parse(tokenString) : null;

const initialState = user ? { isLoggedIn: true, user, token } : { isLoggedIn: false, user: null, token: null };

export default function authReducer(state = initialState, action: any) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        token: null,
      };
    case SET_USER:
      return {
        ...state,
        user: payload.user,
      };
    default:
      return state;
  }
}
